// src/services/events.js
import api from './api';

export const eventsService = {
  getEvents: async (filters = {}) => {
    // Clean and format filters
    const cleanedFilters = {};
    
    for (const [key, value] of Object.entries(filters)) {
      if (value !== '' && value !== null && value !== undefined) {
        // Handle datetime fields
        if (key === 'start_time' || key === 'end_time') {
          let cleanValue = value;
          if (cleanValue.endsWith('Z')) cleanValue = cleanValue.slice(0, -1);
          if (cleanValue.includes('.')) cleanValue = cleanValue.split('.')[0];
          if (cleanValue.length === 16) cleanValue = cleanValue + ':00';
          cleanedFilters[key] = cleanValue;
        } else {
          cleanedFilters[key] = value;
        }
      }
    }
    
    console.log('Sending event filters:', cleanedFilters);
    const response = await api.get('/events/', { params: cleanedFilters });
    return response.data;
  },

  getEvent: async (eventId) => {
    const response = await api.get(`/events/${eventId}`);
    return response.data;
  },

  updateEventStatus: async (eventId, statusData) => {
    const response = await api.put(`/events/${eventId}/status`, statusData);
    return response.data;
  }
};

export default eventsService;
